module.exports = __webpack_public_path__ + "img/c00_buildingtechshieldrim_Normal_ua.45740971.webp";